<script setup lang="ts">
import BaseMessage from '@/overlays/BaseMessage.vue';

type Props = {
  title: string;
};

defineProps<Props>();

defineEmits<{ close: [] }>();
</script>

<template>
  <BaseMessage variant="success" :title="title" @close="$emit('close')" />
</template>
